import { MultiSelect, type MultiSelectProps } from '@mantine/core';

export const MultiSelectInput = ({ size = 'xs', ...props }: MultiSelectProps) => {
    return <MultiSelect size={size} {...props} />;
};
